import React, { useState } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

import { MoreHorizontal } from "lucide-react";
import { VerButawarnaRekap } from "@/types";
import Modal from "@/components/Modal";
import FormKelompok from "./FormKelompok";
import { Link } from "react-router-dom";

export default function Actions({ row }: { row: VerButawarnaRekap }) {
  const [showCreateKelompok, setShowCreateKelompok] = useState(false);
  const [showResetKelompok, setShowResetKelompok] = useState(false);
  const [selectedRow, setSelectedRow] = useState<VerButawarnaRekap | null>(
    null
  );

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowCreateKelompok(true);
                setSelectedRow(row);
              }}
            >
              Buat Kelompok
            </DropdownMenuItem>
            <Link
              to={`/admin/setting/verifikator/butawarna/detail?id=${row.id_verbutawarna_rekap}`}
            >
              <DropdownMenuItem>Lihat Kelompok</DropdownMenuItem>
            </Link>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                setShowResetKelompok(true);
                setSelectedRow(row);
              }}
            >
              Reset Kelompok
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal
        show={showCreateKelompok}
        onClose={() => setShowCreateKelompok(false)}
      >
        <FormKelompok
          closeModal={() => setShowCreateKelompok(false)}
          selectedRow={selectedRow}
          method="POST"
        />
      </Modal>

      <Modal
        show={showResetKelompok}
        onClose={() => setShowResetKelompok(false)}
      >
        <FormKelompok
          closeModal={() => setShowResetKelompok(false)}
          selectedRow={selectedRow}
          method="DELETE"
        />
      </Modal>
    </React.Fragment>
  );
}
